import React, { useState } from "react";

const steps = [
  {
    title: "Discovery and Consultation",
    paras: [
      "We begin by understanding your business, products, customers, and existing ecommerce setup.",
    ],
    listIntro: "During this stage, we discuss:",
    list: [
      "Business goals",
      "Customer journey",
      "Current platform challenges",
      "Required integrations",
      "Future growth plans",
      "Design expectations",
    ],
    outro:
      "This helps us recommend the right Shopify Plus solution rather than a one-size-fits-all approach.",
  },
  {
    title: "Planning and Store Architecture",
    paras: [
      "Once the project requirements are finalized, we create a detailed development roadmap.",
    ],
    listIntro: "This includes:",
    list: [
      "Store structure",
      "Navigation planning",
      "Collection hierarchy",
      "Product organization",
      "User experience planning",
      "Technical architecture",
    ],
    outro:
      "Good planning reduces future development issues and makes your store easier to manage.",
  },
  {
    title: "Design and User Experience",
    paras: [
      "A well-designed ecommerce store should help customers find products quickly and complete purchases without confusion.",
    ],
    listIntro: "Our design approach focuses on:",
    list: [
      "Clear navigation",
      "Mobile-first layouts",
      "Easy product discovery",
      "Fast checkout experience",
      "Consistent branding",
      "Accessible design",
    ],
    outro: "Every design decision is made with usability in mind.",
  },
  {
    title: "Shopify Plus Development",
    paras: [
      "Our Shopify Plus developers build your store using clean development practices and Shopify's latest features.",
    ],
    listIntro: "Development may include:",
    list: [
      "Custom theme development",
      "Shopify Functions",
      "Checkout extensibility",
      "App integrations",
      "Custom sections",
      "B2B functionality",
      "API integrations",
      "Performance improvements",
    ],
    outro: "We also ensure the code remains maintainable for future updates.",
  },
  {
    title: "Testing and Quality Assurance",
    paras: ["Before launch, every store goes through detailed testing."],
    listIntro: "We verify:",
    list: [
      "Mobile responsiveness",
      "Browser compatibility",
      "Checkout flow",
      "Payment gateways",
      "Shipping methods",
      "Forms",
      "Integrations",
      "Store speed",
      "Broken links",
      "SEO settings",
    ],
    outro: "Testing helps identify issues before customers do.",
  },
  {
    title: "Launch and Ongoing Support",
    paras: ["Launching a store is only one milestone."],
    listIntro: "After launch, we continue to help with:",
    list: [
      "Store improvements",
      "Feature updates",
      "Performance monitoring",
      "Technical support",
      "Conversion optimization",
      "Shopify Plus consultation",
    ],
    outro: "As your business grows, your store can continue evolving with it.",
  },
];

export default function Section12() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <div className="w-full Section12 py-[4%]">
      <div className="w-[90%] md:w-[80%] mx-auto section12-container">
        <div className="w-full md:w-[70%] mx-auto text-center pb-[4%]">
          <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
            Our Shopify Plus Development Process
          </h2>
          <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
            Every successful ecommerce project starts with a clear plan.
            Instead of jumping straight into development, we follow a
            structured process that reduces delays, improves collaboration,
            and ensures the final store supports your business goals.
          </p>
        </div>

        <div className="w-full md:w-[80%] mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className="border-l-2 border-[#EDEDED] pl-6 md:pl-8 relative pb-8 last:pb-0"
            >
              <span
                className={`absolute -left-[15px] top-0 w-[28px] h-[28px] rounded-full flex items-center justify-center text-white text-xs font-bold font-open ${
                  openIndex === index ? "bg-[#DA2128]" : "bg-[#B9BBC0]"
                }`}
              >
                {index + 1}
              </span>

              <div
                onClick={() => toggle(index)}
                className="cursor-pointer flex justify-between items-center"
              >
                <h3 className="text-[17px] md:text-[20px] font-bold leading-[26px] text-[#151515] my-[0.4em]">
                  {step.title}
                </h3>
                <b className="text-[26px] text-[#DA2128] font-[300] ml-3 shrink-0">
                  {openIndex === index ? "-" : "+"}
                </b>
              </div>

              {openIndex === index && (
                <div className="font-open">
                  {step.paras.map((p, i) => (
                    <p key={i} className="leading-[22px] text-sm md:text-base text-[#373737] mb-3">
                      {p}
                    </p>
                  ))}
                  <p className="text-sm md:text-base font-bold text-[#151515] mb-2">
                    {step.listIntro}
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 mb-3">
                    {step.list.map((item) => (
                      <li key={item} className="flex items-start text-sm md:text-base text-[#373737]">
                        <span className="text-[#DA2128] text-lg leading-[20px] mr-2">•</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p className="leading-[22px] text-sm md:text-base text-[#373737]">
                    {step.outro}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="line mt-[55px] md:mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}